"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var useDidMount = function (callback) {
    React.useEffect(function () {
        callback();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
exports.default = useDidMount;
